export function resolveVisiblePanelTabs<T extends { id?: string }>({
  persistedItems,
  persistedSelectedIndex,
  defaultTabs,
  isTabIncluded,
  mapTab,
}: {
  persistedItems: readonly T[];
  persistedSelectedIndex: number | undefined;
  defaultTabs: readonly T[];
  isTabIncluded?: (tab: T) => boolean;
  mapTab?: (tab: T) => T;
}): { sourceTabs: T[]; selectedTabId: string | undefined } {
  const includedTabs = (tabs: readonly T[]) => (isTabIncluded ? tabs.filter(isTabIncluded) : [...tabs]);

  const persistedVisible = includedTabs(persistedItems);
  const usingPersisted = persistedVisible.length > 0;
  const sourceTabs = usingPersisted ? persistedVisible : includedTabs(defaultTabs);

  if (sourceTabs.length === 0) {
    return { sourceTabs, selectedTabId: undefined };
  }

  const rawSelectedIndex = usingPersisted ? (persistedSelectedIndex ?? 0) : 0;
  const candidate = usingPersisted ? persistedItems[rawSelectedIndex] : sourceTabs[0];
  const selectedTab = candidate != null && sourceTabs.includes(candidate) ? candidate : sourceTabs[0];
  const selectedIndex = sourceTabs.indexOf(selectedTab);

  return {
    sourceTabs: mapTab ? sourceTabs.map(mapTab) : sourceTabs,
    selectedTabId: selectedTab.id ?? `tab-${selectedIndex}`,
  };
}
